import React, { useState } from "react"

import VideoCard from "../videoCard"
import Pagination from "../pagination"
const SingThursday = ({ singThursday }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [songsPerPage] = useState([5])
  const indexOfLastSong = currentPage * songsPerPage
  const indexOfFirstSong = indexOfLastSong - songsPerPage
  const currentSongs = singThursday.slice(indexOfFirstSong, indexOfLastSong)

  const paginate = (pageNumber) => setCurrentPage(pageNumber)
  return (
    <section className="sing-thursday">
      <h1 className="heading">Sing Thursday Season 01</h1>
      <div className="showcase">
        {currentSongs.map((video, index) => (
          <VideoCard
            key={index}
            id={video.id}
            title={video.title}
            src={video.src}
            descr={video.descr}
            type={video.type}
            artist={video.artist}
            cover={video.coverImg}
            singThursday={video.singThursday}
          />
        ))}
      </div>
      <Pagination
        songsPerPage={songsPerPage}
        totalSongs={singThursday.length}
        paginate={paginate}
        indexOfLastSong={indexOfLastSong}
      />
    </section>
  )
}

export default SingThursday
